export default "__VITE_ASSET__89mDZOBd__";